// src/features/assistant-connect/utils/surface.ts
//
// Which Insight this browser is pointed at, classified from the API address the build calls (the
// base URL is what actually gets called, not the build mode).

export type InsightEnvironment = 'production' | 'test' | 'local' | 'unknown';

export interface InsightSurface {
  /** Host alone, for a compact label. Empty when the base URL cannot be parsed. */
  host: string;
  environment: InsightEnvironment;
}

const PRODUCTION_HOSTS = ['insight-api.roommatik.com'];
const TEST_HOSTS = ['dev-insight-api.roommatik.com'];
const LOCAL_HOSTS = ['localhost', '127.0.0.1', '[::1]'];

/**
 * Classifies the configured API address. Anything unrecognised stays `unknown` on purpose, so the
 * page can say so instead of presenting a production Insight as a sandbox.
 */
export const describeSurface = (baseUrl: string | undefined | null): InsightSurface => {
  const trimmed = (baseUrl ?? '').trim();
  if (!trimmed) return { host: '', environment: 'unknown' };

  let host = '';
  try {
    host = new URL(trimmed).hostname.toLowerCase();
  } catch {
    return { host: '', environment: 'unknown' };
  }

  const environment: InsightEnvironment = PRODUCTION_HOSTS.includes(host)
    ? 'production'
    : TEST_HOSTS.includes(host)
      ? 'test'
      : LOCAL_HOSTS.includes(host)
        ? 'local'
        : 'unknown';

  return { host, environment };
};
